import React,{ useEffect, useState } from 'react'
import { TabItem,DetailContainer, TabImg, TabHead, TabTitle } from '../../StyledComponents/CreateKeyAccountManager'
// import ProfileSection from './ProfileSection';
// import QuoteSection from './QuoteSection';
import ActionSectionAdmin from '../../components/Admin/UserManagement/ActionSectionAdmin';
// import ProfileSectionAdmin from './ProfileSectionAdmin';
import Organizationadd from '../../components/Admin/UserManagement/Organizationadd';
// import ContentHead from '../Common/ContentHead';
import { Menu } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import styled from 'styled-components/macro';
//
import { LeftHead, SubHeadContainer, SubHeadTitle, TitleHead } from '../../StyledComponents/Common';
//
import { IconImg } from '../../StyledComponents/Header';
// import { UserIDContainer, UserText } from '../../../StyledComponents/KYCVerifications';
// import AddButton from '../Common/AddButton';
// import QuoteSectionAdmin from './QuoteSectionAdmin';
import { useLocation, useNavigate } from 'react-router-dom';
// import { get_param_url } from '../../functions/Utils';
import { get_param_url } from '../../functions/Utils';
import CreditDetails from '../../components/Admin/UserManagement/CreditDetails';


// Same dark tone for every tab label/icon, selected or not.
const TAB_TEXT_COLOR = '#242424';
function Organizationdetailspage(props) {
  console.log("props", props) 
    const navigate = useNavigate()
    const [openKeys, setOpenKeys] = useState(props.tab === "2" ? ['services'] : []);
    const [currentTab, setCurrentTab] = useState(props.tab? props.tab : "1");
    const [currentSubTab, setCurrentSubTab] = useState(props.tab? props.tab : "1");
    const location = useLocation();
    const [isLoad, setIsLoad] = useState(true);
  //    const isOrganizationCreated = useSelector(
  //   (state) => state.organization.isOrganizationCreated
  // );
  // console.log("hiiiijdcnbfjncjk",isOrganizationCreated);
    useEffect(()=> {
      if(location.pathname === '/user-management-admin'){
        console.log("hii", props)
        if(isLoad === false){
          props.setPageType("table")
        }else {
          setIsLoad(false)
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[location])
    
    const callback = (key)=> {
        setCurrentTab(key)
        setCurrentSubTab("1")
        // Expand the Actions sub-menu only while the Actions tab is selected.
        setOpenKeys(key === "2" ? ['services'] : [])
        
    }


    const handleBack = () => {
      const user_id = get_param_url("user_id")
      if(user_id){
        navigate(`/dashboard`)
      }else {
        props.setPageType("table")
      }
      
    }

    const handleMenuClick = ({ key }) => {
        setCurrentSubTab(key)
      };
    
      const handleSubMenuOpen = (keys) => {
        setOpenKeys(keys);
      };
console.log(props,"hiii")
    const ItemsMenu = [
      {
        label: <ActionsTitle active={currentTab === "2"}>
            <span>Actions</span>
            {openKeys.includes('services')
              ? <UpOutlined style={{ fontSize: 11 }} />
              : <DownOutlined style={{ fontSize: 11 }} />}
        </ActionsTitle>,
        key: 'services',
        children: [{ label: <TabTitle className='sub-menu' active={currentSubTab === "1"}>Reassign KAM</TabTitle>, key: '1' },
                    { label: <TabTitle className='sub-menu' active={currentSubTab === "2"}>Change Status</TabTitle>, key: '2' },
                  ],
      },
    ]

    // const items = [
    //     {
    //       key: '1',
    //       tab: (
    //         <TabHead>
    //             {currentTab === "1" ? <TabImg src={require('../../../assets/admin/images/user-squaretab_active.png')} />:<TabImg src={require('../../../assets/admin/images/user-squaretab.png')} /> }
    //             <TabTitle active={currentTab === "1"}>
    //                 Profile
    //             </TabTitle>
    //         </ TabHead>
    //       ),
    //       content: <ProfileSectionAdmin instance={props.instance} is_edit={is_edit} handleCancel={handleCancel} setPageType={props.setPageType} />,
    //     },
    //     {
    //       key: '2',
    //       tab: (
    //         <TabHead>
    //             {currentTab === "2" ? <TabImg src={require('../../../assets/admin/images/finger-scantab_active.png')} />:<TabImg src={require('../../../assets/admin/images/finger-scantab.png')} /> }
    //             <TabTitle active={currentTab === "2"}>
    //                 Quotes Accepted
    //             </TabTitle>
    //         </ TabHead>
    //       ),
    //       content: <QuoteSectionAdmin instance={props.instance} type="accepted" setQueryInstance={props.setQueryInstance} />,
    //     },
    //     // {
    //     //     key: '3',
    //     //     tab: (
    //     //       <TabHead className='user-admin'>
    //     //           {currentTab === "3" ? <TabImg src={require('../../../assets/admin/images/action_tab_active.png')} />:<TabImg src={require('../../../assets/admin/images/action_tab.png')} /> }
    //     //           <MenuItem
    //     //             mode="inline"
    //     //             openKeys={openKeys}
    //     //             onOpenChange={handleSubMenuOpen}
    //     //             onClick={handleMenuClick}
    //     //             items={ItemsMenu}
    //     //             />
    //     //             {/* <SubMenu key="services" title={<TabTitle className='user-admin' active={currentTab === "3"}>
    //     //               Actions
    //     //           </TabTitle>}>
    //     //                 <Menu.Item key="1"><TabTitle className='user-admin sub-menu' active={currentSubTab === "1"}>Reassign KAM</TabTitle></Menu.Item>
    //     //                 <Menu.Item key="2"><TabTitle className='user-admin sub-menu' active={currentSubTab === "2"}>Change Status</TabTitle></Menu.Item>
    //     //             </SubMenu>
    //     //             </MenuItem> */}
    //     //       </ TabHead>
    //     //     ),
    //     //     content: <ActionSectionAdmin instance={props?.instance} kam_list={props.kam_list} setPageType={props.setPageType} currentSubTab={currentSubTab} setInstance={props.setInstance} />,
    //     // },
    //     // {
    //     //     key: '4',
    //     //     tab: (
    //     //       <TabHead>
    //     //           {currentTab === "4" ? <TabImg src={require('../../../assets/admin/images/credit_details_active.png')} />:<TabImg className='grey' src={require('../../../assets/admin/images/credit_details_active.png')} /> }
    //     //           <TabTitle active={currentTab === "4"}>
    //     //             Credit Details
    //     //           </TabTitle>
    //     //       </ TabHead>
    //     //     ),
    //     //     content: <CreditDetails instance={props.instance} setPageType={props.setPageType} currentSubTab={currentSubTab} setInstance={props.setInstance} />,
    //     // },
    //   ];
     
      const items1 = [
        {
          key: '1',
          tab: (
            <TabHead>
                {currentTab === "1" ? <TabImg style={{ filter: 'brightness(0)' }} src={require('../../assets/admin/images/user-squaretab_active.png')} />:<TabImg style={{ filter: 'brightness(0)' }} src={require('../../assets/admin/images/user-squaretab.png')} /> }
                <TabTitle style={{ color: TAB_TEXT_COLOR }} active={currentTab === "1"}>
                  Profile
                </TabTitle>
            </ TabHead>
          ),
          content: <Organizationadd instance={props} />,
        },
        {
          key: '2',
          tab: (
            <TabHead className='user-admin actions-tab'>
                {currentTab === "2" ? <TabImg style={{ filter: 'brightness(0)' }} src={require('../../assets/admin/images/action_tab_active.png')} />:<TabImg style={{ filter: 'brightness(0)' }} src={require('../../assets/admin/images/action_tab.png')} /> }
                <MenuItem
                  mode="inline"
                  openKeys={openKeys}
                  selectedKeys={[currentSubTab]}
                  onOpenChange={handleSubMenuOpen}
                  onClick={handleMenuClick}
                  items={ItemsMenu}
                  />
                  {/* <SubMenu key="services" title={<TabTitle className='user-admin' active={currentTab === "3"}>
                    Actions
                </TabTitle>}>
                      <Menu.Item key="1"><TabTitle className='user-admin sub-menu' active={currentSubTab === "1"}>Reassign KAM</TabTitle></Menu.Item>
                      <Menu.Item key="2"><TabTitle className='user-admin sub-menu' active={currentSubTab === "2"}>Change Status</TabTitle></Menu.Item>
                  </SubMenu>
                  </MenuItem> */}
            </ TabHead>
          ),
          content: <ActionSectionAdmin instance={props?.instance} kam_list={props.kam_list} setPageType={props.setPageType} currentSubTab={currentSubTab} setInstance={props.setInstance} isActive={currentTab === "2"} />,
      },
      {
          key: '3',
          tab: (
            <TabHead>
                {/* The only asset is orange; brightness(0) renders it black like the other tab icons. */}
                <TabImg style={{ filter: 'brightness(0)' }} src={require('../../assets/admin/images/credit_details_active.png')} />
                <TabTitle style={{ color: TAB_TEXT_COLOR }} active={currentTab === "3"}>
                  Credit Details
                </TabTitle>
            </ TabHead>
          ),
          content: <CreditDetails instance={props.instance} setPageType={props.setPageType} currentSubTab={currentSubTab} setInstance={props.setInstance} />,
      },
      ];
      console.log(props,"props")
  return (
    <>
    {/* <ContentHead title="User Details" is_button={true} is_edit={currentTab === "1" ? is_edit : true} handleClick={()=> props.setPageType("table")} handleEdit={handleEdit} /> */}
    <SubHeadContainer className='flex-column'>
      <LeftHead className='space-btwn'>
          <TitleHead>
            <IconImg onClick={()=> handleBack()} src={require('../../assets/admin/images/back_page_arrow.png')} />
            <SubHeadTitle>User Details</SubHeadTitle>
          </TitleHead>
          {/* <AddButton title="Edit" icon_type="edit" handleClick={handleEdit}  /> */}
      </LeftHead>
      {/* <UserIDContainer>
        <UserText>USER ID</UserText>
        <UserText className='value'>{props?.instance?.id}</UserText>
      </UserIDContainer> */}
  </SubHeadContainer>
    <DetailContainer className='user-management'>
       <OrgTabs
        tabPosition="left"
        defaultActiveKey={props.tab? props.tab : "1"}
        onChange={callback}
        items={items1.map((i,idx) => {
            return {
              label: i.tab,
              key: i.key,
              children: i.content,
            };
          })}
      />
    </DetailContainer>
    </>
    
  )
}

export default Organizationdetailspage


// Lets the Actions tab content span the full pill width (so the arrow can sit at the
// right edge) while Profile / Credit Details keep their icon + label left-aligned.
const OrgTabs = styled(TabItem)`
    & .ant-tabs-tab-btn {
        flex: 1;
        min-width: 0;
    }
    & .ant-tabs-tab-btn > div {
        justify-content: flex-start;
    }
    /* Keep the warning icon on the "Actions" line instead of centred on the whole block. */
    & .actions-tab {
        align-items: flex-start !important;
    }
`

// "Actions" on the left, open/close arrow pinned to the right edge of the pill.
const ActionsTitle = styled.span`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-family: 'Rubik';
    font-size: 16px;
    font-weight: ${({ active }) => active ? 600 : 400};
    color: ${TAB_TEXT_COLOR};
`

// Transparent menu so the Actions label sits on the tab's own pill background,
// with the sub-items listed beneath it behind a thin guide line.
const MenuItem = styled(Menu)`
    flex: 1;
    min-width: 0;
    background: transparent !important;
    border: none !important;
    text-align: left;
    &.ant-menu-inline, & .ant-menu-inline {
        border-inline-end: none !important;
    }
    & .ant-menu-submenu-title {
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
        height: 24px !important;
        line-height: 24px !important;
        background: transparent !important;
        color: inherit !important;
        :hover {
            background: transparent !important;
        }
    }
    & .ant-menu-submenu-arrow {
        display: none !important;
    }
    & .ant-menu-title-content {
        width: 100%;
        line-height: inherit !important;
        overflow: visible !important;
    }
    & .ant-menu.ant-menu-sub.ant-menu-inline {
        background: transparent !important;
        border: none !important;
        margin: 10px 0 0 !important;
        padding-left: 10px !important;
        border-left: 2px solid rgba(36, 36, 36, 0.15) !important;
    }
    & .ant-menu-item {
        height: 32px !important;
        line-height: 32px !important;
        margin: 0 0 4px !important;
        width: 100% !important;
        padding: 0 12px !important;
        border-radius: 8px !important;
        background: transparent !important;
        color: #3F4254 !important;
        transition: background 0.15s ease;
        ::after {
            display: none !important;
        }
        :last-child {
            margin-bottom: 0 !important;
        }
        :hover {
            background: rgba(255, 255, 255, 0.4) !important;
        }
    }
    & .ant-menu-item-selected {
        background: rgba(255, 255, 255, 0.9) !important;
        color: #242424 !important;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
    }
    & .ant-menu-item .sub-menu {
        font-size: 14px;
    }
`